import React, { useState, useEffect, useCallback } from 'react';
import { Button, Modal, Upload, Skeleton, Input } from 'antd';
import { useSelector } from 'react-redux';
import { API } from '@service';
import alert from '@components/alert';
import FullScreenButton from '@components/fullScreenButton';
import { PDFDownload } from '@components/hubModule/pdfTitleAndDownload';
import useObjectUrl from '@hooks/useObjectURL';
import { FixedRatioSectionWrapper } from '@components/fixedRatioContainer';
import { injectPDFStyleOnIframeLoad } from '@utils/common';
import { getPdfUploadClientError } from '@utils/pdfUploadValidation';
import { filterXSS } from 'xss';

const PDFDisplay = (props) => {
  const {
    identifier,
    link,
    setLink,
    section,
    titleName,
    changeOrderPropsValue,
    onSortEnd,
    sectionOrder,
    type,
    refresh,
  } = props;
  // console.log('PDF Display', { type, link, identifier, titleName });

  const projectId = useSelector((state) => state.common.currentId);
  // const isClient = useSelector(
  //   ({ login }) => login.userInfo.role === USER_ROLE_MODEL.CLIENT,
  // );
  const [hasUploaded, setHasUploaded] = useState(Boolean(link));
  const [showUpload, setShowUpload] = useState(false);
  const [reupload, setReupload] = useState(false);
  const [isdelete, setIsDelete] = useState(false);

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [hotFile, setHotFile] = useState(null);
  const [hotFileName, setHotFileName] = useState(null);
  const [pdfContent, setPdfContent] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [iframeVisible, setIframeVisible] = useState(false);
  const [isExpand, setExpand] = useState(false);
  const [titleError, setTitleError] = useState(false);
  const [titleRepeat, setTitleRepeat] = useState(false);
  const [extValid, setExtValid] = useState(true);
  const [clientPdfError, setClientPdfError] = useState(null);

  const resetState = useCallback(() => {
    setIframeVisible(false);
    setPdfContent(null);
    setFile(null);
    setFileName(null);
    setHotFileName(null);
    setHotFile(null);
    setLink(null);
    setHasUploaded(false);
  }, []);

  useEffect(() => {
    if (!hasUploaded && link && link !== '') {
      setHasUploaded(true);
      return;
    }
    if (hasUploaded && type === 'pdf' && link) {
      (async () => {
        const { data, fileName } = await API.getReportPdf(link);
        setFileName(fileName);
        setFile(data);
        setPdfContent(data);
        setIframeVisible(true);
        setLink(link);
      })();
      // return () => {
      //   // URL.revokeObjectURL(file);
      // };
    } else if (!link) {
      resetState();
    }
  }, [link, hasUploaded]);
  const objectURL = useObjectUrl(pdfContent);

  const validateFile = (newFile) => {
    const clientErr = getPdfUploadClientError(newFile);
    if (clientErr) {
      alert.error(clientErr);
      setClientPdfError(clientErr);
      setExtValid(false);
      return false;
    }
    setClientPdfError(null);
    setExtValid(true);
    const fileReader = new FileReader();
    fileReader.onload = () => {
      if (hasUploaded) {
        setReupload(true);
        setHotFile(newFile);
        setHotFileName(newFile.name);
      } else {
        setFile(newFile);
        setFileName(newFile.name);
      }
      setIsDelete(false);
    };
    fileReader.readAsBinaryString(newFile);
    return false;
  };

  const handleUpload = async () => {
    setConfirmLoading(true);
    if (!file) {
      alert.error('Please choose a file to upload');
      setConfirmLoading(false);
      return;
    }
    const clientErr = getPdfUploadClientError(file);
    if (clientErr) {
      alert.error(clientErr);
      setConfirmLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', fileName);
    const res = await API.uploadReportPdf(projectId, formData);
    setLink(res.id);
    let orders = changeOrderPropsValue(
      sectionOrder,
      section.identifier,
      'titleName',
      document.getElementById('title').value,
    );
    orders = changeOrderPropsValue(orders, section.identifier, 'link', res.id);
    onSortEnd(orders);
    setConfirmLoading(false);
    setShowUpload(false);
    setPdfContent(file);
    setHasUploaded(true);
    setIframeVisible(true);
    setTimeout(refresh, 100);
  };

  const handleDelete = () => {
    setIsDelete(true);
    setHotFileName(null);
    if (!hasUploaded) {
      setFileName(null);
    }
  };

  const handleCancel = () => {
    setConfirmLoading(true);
    setReupload(false);
    setIsDelete(false);
    if (!hasUploaded) {
      setFile(null);
      setFileName(null);
    } else {
      setHotFile(null);
      setHotFileName(null);
    }
    setConfirmLoading(false);
    setShowUpload(false);
    setTitleError(false);
    setExtValid(true);
    setClientPdfError(null);
  };

  const handleSave = async () => {
    setConfirmLoading(true);
    if (!isdelete && !reupload) {
      setConfirmLoading(false);
    } else if (reupload && !isdelete) {
      const uploadErr = getPdfUploadClientError(hotFile);
      if (uploadErr) {
        alert.error(uploadErr);
        setConfirmLoading(false);
        return;
      }
      const formData = new FormData();
      formData.append('file', hotFile);
      formData.append('name', hotFileName);
      const res = await API.editReportPdf(link, formData);
      console.log(res);
      setFile(hotFile);
      setFileName(hotFileName);
      setPdfContent(hotFile);
      setHotFile(null);
      setHotFileName(null);
    } else if (isdelete) {
      const res = await API.deleteReportPdf(link);
      console.log(res);
      resetState();
    } else {
      console.log('pdf no change');
    }
    setReupload(false);
    setIsDelete(false);
    let orders = changeOrderPropsValue(
      sectionOrder,
      section.identifier,
      'titleName',
      document.getElementById('title').value,
    );
    if (isdelete) {
      orders = changeOrderPropsValue(orders, section.identifier, 'link', null);
    }
    onSortEnd(orders);
    setConfirmLoading(false);
    setShowUpload(false);
  };

  const renderFooter = (
    <div>
      <Button loading={confirmLoading} onClick={handleCancel}>
        Cancel
      </Button>
      <Button
        type="primary"
        loading={confirmLoading}
        onClick={hasUploaded ? handleSave : handleUpload}
        disabled={(!hasUploaded && !fileName) || titleError || !extValid}
      >
        {hasUploaded ? 'Save' : 'Upload'}
      </Button>
    </div>
  );

  const titleWarning = (
    <div className="title-warning">
      {titleRepeat
        ? '* The name already exists, please enter another name.'
        : '* The title is required'}
    </div>
  );

  const checkInput = (e) => {
    let isRepeat, isBlank;
    isRepeat = isBlank = false;
    sectionOrder.forEach((item) => {
      if (e.target.value === '') {
        isBlank = true;
      } else if (
        item.identifier !== section.identifier &&
        item.titleName === e.target.value
      ) {
        isRepeat = true;
      }
    });
    setTitleRepeat(isRepeat);
    setTitleError(isRepeat || isBlank);
  };

  return (
    <>
      {hasUploaded ? (
        <div className="powerbi-title-link">
          <div className="left">
            <span className="title">{titleName}</span>
          </div>
          <div className="right">
            <FullScreenButton
              elemId={`#fullscreen-${identifier}`}
              onToggleFullScreen={() => setExpand((e) => !e)}
            />
          </div>
        </div>
      ) : (
        <>
          <span className="powerbi-title">{titleName}</span>
          <Button
            type="primary"
            style={{
              fontWeight: 500,
              marginLeft: 10,
            }}
            onClick={() => {
              setShowUpload(true);
            }}
            className="role-control"
          >
            {!hasUploaded ? 'Upload PDF' : 'Edit PDF'}
          </Button>
        </>
      )}
      {hasUploaded && link && (
        <FixedRatioSectionWrapper
          className="pdf-fullscreen-div"
          id={`fullscreen-${identifier}`}
          ratio={section.ratio}
        >
          {iframeVisible && (
            <>
              <div
                style={{
                  display: 'table',
                  position: 'absolute',
                  backgroundColor: 'rgb(51,54,57)',
                  color: 'white',
                  fontWeight: 500,
                  top: '0.75rem',
                  left: '4.0625rem',
                  height: '2.75rem',
                  width: 'calc((100% - 3.125rem - 31.25rem) / 2)',
                  lineHeight: '1.563rem',
                }}
              >
                <span
                  style={{
                    display: 'table-cell',
                    verticalAlign: 'middle',
                    wordBreak: 'break-all',
                  }}
                >
                  {fileName}
                </span>
              </div>
              <PDFDownload
                pdfContent={{ contentBlob: pdfContent, fileName }}
                style={{
                  right: isExpand ? '8.75rem' : '7rem',
                  top: '0.875rem',
                }}
              />
              <iframe
                title="inte-iframe"
                className="external-iframe"
                // src={`${URL.createObjectURL(pdfContent)}`}
                onLoad={injectPDFStyleOnIframeLoad}
                src={filterXSS(objectURL)}
              />
            </>
          )}
        </FixedRatioSectionWrapper>
      )}

      <Modal
        className="upload-modal upload-pdf"
        title={!hasUploaded ? 'Upload PDF' : 'Edit PDF'}
        visible={showUpload}
        onCancel={handleCancel}
        footer={renderFooter}
        destroyOnClose
      >
        <div className="modal-name-label">Section Name</div>
        <Input
          id="title"
          defaultValue={titleName}
          maxLength={100}
          onChange={checkInput}
          autoComplete="off"
        />
        {titleError && titleWarning}
        <div className="file-upload-label">PDF File</div>
        <Upload.Dragger
          beforeUpload={(newFile) => validateFile(newFile)}
          maxCount={1}
          showUploadList={false}
          accept=".pdf,application/pdf"
        >
          Drag and drop or <span>choose your files</span>
          {hasUploaded ? ' to reupload' : null}
        </Upload.Dragger>

        {(!isdelete || reupload) &&
          ((!reupload && fileName) || (reupload && hotFileName)) && (
            <>
              <div className="file-list">
                <Skeleton paragraph={false} active loading={false}>
                  <div className="file-name">
                    {reupload ? hotFileName : fileName}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <span
                      className="appkiticon icon-circle-delete-fill"
                      onClick={handleDelete}
                    />
                  </div>
                </Skeleton>
              </div>
              {!extValid && clientPdfError ? (
                <div className="active-color">{clientPdfError}</div>
              ) : null}
            </>
          )}
      </Modal>
    </>
  );
};

export default PDFDisplay;
